import { useState } from "react";
import coursesService from "./useCardListService";
import { useQuery } from "react-query";
import useDebounce from "../../../../../core/hooks/useDebounce";
import { message } from "antd";
import { useNavigate } from 'react-router-dom';

const useCardList = () => {
  const [search, setSearch] = useState("");
  const { debouncedValue } = useDebounce(search, 1000);
  const [page, setPage] = useState(1);

  const navigate = useNavigate()
  const handleNavigate = ()=> navigate("/create-course")


  const { data, isLoading, error, refetch, isFetching : isFetchingCourses } = useQuery(
    ["PopularCoursesData", debouncedValue, page,search],
    () => coursesService.getCoursesData({filterOptions: JSON.stringify({searchText:search}), pageOptions: JSON.stringify({page:page,take:11})}),
    {
      initialData: {
        data: { data: [], meta: { hasPrevious: false, hasNext: false } },
      },
      keepPreviousData: true,
      // staleTime: 5000
    },
    // {
    //   onSuccess: () => {
    //     setSearch("")
    //     refetch()
    //   }
    // },
  );


  function handleSearchChange(event) {
    setSearch(event.target.value);
    setPage(1);
  }

  function handleCategoryChange(event) {
    setSearch(event.target.value);
    setPage(1);
  }

  const handleNext = () => {
    setPage((page) => page + 1);
  };

  const handlePrevious = () => {
    setPage((page) => page - 1);
  };

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleFetchAll = async () =>{
    setSearch("")
    await refetch();
  }

  const cancel = (e) => {
    e.stopPropagation();
  };

  const handleDeleteCourse = async (id, e) => {
    e.stopPropagation();
    try {
      await coursesService.deleteCourse(id);
      await refetch();
      message.success("Course deleted successfully");
    } catch (error) {
      console.log(error.response.status);
      if(error.response.status === 409){
        message.error("Deletion not permitted, some trainings have started.");
      }
      else if (error.response.status === 404){
        message.error("Course not found !");
      }
      else{
        message.error("An error occurred while deleting the course.!");
      }
    }
  };
  return {
    data: data?.data?.data,
    meta: data.data.meta,
    isLoading,
    error,
    debouncedValue,
    handleSearchChange,
    handleNext,
    handlePrevious,
    handlePageClick,
    handleDeleteCourse,
    cancel,
    handleNavigate,
    isFetchingCourses,
    handleCategoryChange,
    handleFetchAll
  };
};

export default useCardList;
